<template>
    <div>
        <div class="common-header">
            <router-link :to="{name:'clubRecommend'}">
                <el-button type="primary">推荐俱乐部管理</el-button>
            </router-link>

            <div class="common-header-right">
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" @change="searchClubList()"/>
                </div>

                <div class="common-header-block">
                    <el-input
                            class="common-el-input"
                            placeholder="输入俱乐部昵称或ID查询"
                            v-model="searchVal">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="searchClubList()">搜索</el-button>
                </div>
            </div>
        </div>
        <div>
            <strong class="common-text-item" v-text="`俱乐部总数：${clubList.total}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="clubList.beanList"
                    row-key="clubRandomId"
                    height="100%"
                    @row-click="rowClick">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" align="center" prop="userRandomId" width="150"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="creatorName"/>
                <el-table-column label="俱乐部昵称" width="180" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubRandomId"/>
                <el-table-column label="参数设置" align="center">
                    <template slot-scope="scope">{{scope.row.profit}}%
                        <i class="el-icon-edit-outline" @click.stop="setConfigFunc(scope.row)"></i></template>
                </el-table-column>
              <el-table-column label="联盟分成" align="center">
                <template slot-scope="scope">{{scope.row.tribeProfit}}%</template>
              </el-table-column>
              <el-table-column label="对赌设置" align="center">
                <template slot-scope="scope">{{scope.row.clubRabtio}}%
                  <i class="el-icon-edit-outline" @click.stop="setClubConfigFunc(scope.row)"></i></template>
              </el-table-column>
              <el-table-column label="联盟对赌比例" align="center">
                <template slot-scope="scope">{{numberRabtio(scope.row.recordRabtio,scope.row.clubRabtio)}}%</template>
              </el-table-column>
              <el-table-column label="是否开启" align="center">
                <template slot-scope="scope">{{scope.row.open?'开启':'关闭'}}</template>
              </el-table-column>
                <el-table-column label="联盟" align="center" width="150" prop="tribeName">
                    <template slot-scope="scope">{{scope.row.tribeName}}
                        <i class="el-icon-edit-outline" @click.stop="setConfigFunc(scope.row)"></i></template>
                </el-table-column>
                <el-table-column label="总人数" align="center" prop="clubMembers"/>
                <el-table-column label="主联盟" min-width="150" align="center" prop="mainTribeName"/>
                <el-table-column label="交易模式" align="center" width="100">
                    <template slot-scope="scope">{{scope.row.transType | topUpTypeName}}</template>
                </el-table-column>
                <el-table-column label="基金仓" min-width="120" align="center" prop="fund">
                  <template slot-scope="scope">{{scope.row.fund | numberChip}}</template>
                </el-table-column>
              <el-table-column label="对赌基金仓" min-width="120" align="center" prop="fund">
                <template slot-scope="scope">{{scope.row.chip | numberChip}}</template>
              </el-table-column>
                <el-table-column label="是否开启战绩返佣" align="center" width="150">
                    <template slot-scope="scope">{{scope.row.openRebate?'是':'否'}}</template>
                </el-table-column>
                <el-table-column label="推广员数量" width="120" align="center" prop="promoterNumbers"/>
                <el-table-column label="推广员业绩" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.promoterAchievement}} 记分牌</template>
                </el-table-column>
                <el-table-column label="推广玩家数量" width="120" align="center" prop="notPromoterNumbers"/>
                <el-table-column label="返豆支出" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.clubBackChips}} 金豆</template>
                </el-table-column>

                <el-table-column label="联系方式" width="150" align="center" prop="contact"/>
                <el-table-column label="业绩流水" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.clubAchievement}} 记分牌</template>
                </el-table-column>
                <el-table-column label="服务费" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.totalFree}} 记分牌</template>
                </el-table-column>
                <el-table-column label="保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.totalInsurance}} 记分牌</template>
                </el-table-column>
                <el-table-column label="获得JP值" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.clubWinJp}} 记分牌</template>
                </el-table-column>
                <el-table-column label="总利润" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.totalWin}} 记分牌</template>
                </el-table-column>
                <el-table-column label="总收益" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.clubTotalCommission}} 记分牌</template>
                </el-table-column>
                <el-table-column label="创建时间" width="150" align="center" prop="createTime"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="clubList.total"
                :current-page="currentPage"
                @current-change="searchClubList({page:$event})"/>
        <comp-club-config ref="config" :info="configInfo" @my-submit="searchClubList({page: currentPage})"/>
      <comp-club-rebate-config ref="rebate" :info="configInfo" @my-submit="searchClubList({page: currentPage})"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import compClubConfig from './compClubConfig'
    import compClubRebateConfig from "./compClubRebateConfig";

    export default {
        components:{
            compClubConfig,
            compClubRebateConfig
        },
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
                configInfo:{},
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('club', ['clubList']),
            userType() {
                return localStorage.getItem('authTypeCode')
            }
        },
        created() {
            this.searchClubList();
        },
        methods: {
            ...mapActions('club', ['getClubList', 'updateClubConfig']),
            // 俱乐部列表
            searchClubList(obj = {}) {
                this.loading = true;
                let params = {
                    content: this.searchVal,
                    start: this.date ? this.date[0] : '',
                    end: this.date ? this.date[1] : '',
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getClubList(params).then(() => {
                    this.loading = false;
                })
            },
          numberRabtio(val,val1){
            return val - val1 < 0 ?0 : val - val1;
          },
            // 俱乐部配置
            setConfigFunc(row) {
                this.configInfo = row;
                this.$refs.config.show = true;
            },
            // 俱乐部对赌配置
            setClubConfigFunc(row){
              this.configInfo = row;
              this.$refs.rebate.show = true;
            },
            rowClick(row) {
                this.$router.push({name: 'clubDetail', params: {id: row.id}})
            }
        }
    }
</script>
<style lang="scss" scoped>
    :global(.el-icon-edit-outline) {
        color: $theme-color;
        cursor: pointer;
    }
</style>